import React, { Component } from 'react';
import { Carousel } from 'antd';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { css } from '@emotion/core';
import eNums from '../../../constants/enums';
import SubscriptionPlanCard from '../../SettingTabs/Subscription/SubscriptionPlanCard';
import { PlansContainer } from '../../SettingTabs/Subscription/styled';
import Spinner from '../../common/spinner';
import { CustomPlan } from './index';
import { colors } from '../../../constants';
import { Arrow } from '../../common/styled';
import SubscriptionCustomPlanCard from '../../SettingTabs/Subscription/SubscriptionCustomPlanCard';

@injectIntl
@inject('onboardingStore')
@inject('settingsStore')
@inject('localeStore')
@observer
class QuickSubscriptionPicker extends Component {
  constructor() {
    super();
    this.carouselRef = React.createRef();
    this.state = {
      isMonthlyPayment: true,
      hoveringCardVisible: false,
      clickedPlanIndex: -1,
      initialSlide: null,
      disableUpgradePlan: false,
      clickedPlanBCR: null,
    };
    this.closeCard = this.closeCard.bind(this);
  }

  componentDidMount() {
    const {
      settingsStore: {
        subscription: { currentPlanId, displayedPlansOnboarding },
      },
    } = this.props;

    const currPlanIndex = displayedPlansOnboarding
      .filter(
        plan =>
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      )
      .findIndex(p => p.id === currentPlanId);
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      initialSlide: currPlanIndex === -1 ? 0 : currPlanIndex,
      disableUpgradePlan: currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
    });
    const parts = window.location.hash.slice(1).split('-');
    if (parts[1]) {
      this.handlePlanCardClick(null, parts[1]);
    }
  }

  closeCard = () => {
    this.setState({
      hoveringCardVisible: false,
    });
  };

  openCard = (index = -1, bcr) => {
    this.setState(
      {
        clickedPlanIndex: index,
        hoveringCardVisible: true,
        clickedPlanBCR: bcr,
      },
      () => {
        if (bcr) {
          const element = document.querySelector(`#tm-popped-over-plan-card`);
          element.children[0].className = element.children[0].className.replace(
            /\btm-plan-initial-pos\b/g,
            '',
          );
        }
      },
    );
  };

  handlePlanCardClick = (index, id) => {
    const bcr = document.querySelector(`#tm-${index}-card`)?.getBoundingClientRect();
    let actualIndex = index;
    if (typeof index !== 'number' && !index) {
      actualIndex = this.loadURLPlan(id);
    }
    this.openCard(actualIndex, bcr);
  };

  confirmPlanChange = (planId, addOns,purchaseId) => {
    const {
      settingsStore: {
        subscription: { upgradePlan, currentPlanId },
      },
    } = this.props;
    if (currentPlanId !== planId) {
      upgradePlan(planId, addOns,purchaseId).then(() => {});
    }
    this.setState({
      hoveringCardVisible: false,
    });
  };

  goToSlide = () => {
    this.carouselRef.current.goTo(6, true);
  };

  render() {
    const {
      intl,
      localeStore: { isJA },
      settingsStore: {
        subscription: {
          currentPlanId,
          currentPlan,
          displayedPlansOnboarding,
          firstPlanIndexOnboarding,
          loading,
          billableAccounts,
          billablePayoneerAccounts,
        },
        userProfile: { isNonApi },
      },
      onboardingStore,
    } = this.props;

    const billingAccount = billableAccounts || billablePayoneerAccounts;

    if (currentPlanId === null) {
      onboardingStore.disableNextWizard();
    } else {
      onboardingStore.enableNextWizard();
    }

    const {
      hoveringCardVisible,
      clickedPlanIndex,
      isMonthlyPayment,
      initialSlide,
      disableUpgradePlan,
      clickedPlanBCR,
    } = this.state;

    const clickedPlan =
      displayedPlansOnboarding.filter(
        plan =>
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
          plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
      )[clickedPlanIndex] || null;
    const hoveringCardAction = this.confirmPlanChange;
    const hoveringCardButtonMessage = intl.formatMessage({ id: 'subscription.agree' });

    return (
      <>
        <PlansContainer
          css={css`
            height: 570px;
            padding: 1em 2em 2em 2em;
          `}
        >
          {/* check if there are any custom plans and display button to scroll carousel to custom plan  */}
          {displayedPlansOnboarding.some(plan => plan.maxListedItems > 10000) && (
            <CustomPlan goToSlide={this.goToSlide} />
          )}
          {initialSlide !== null && (
            <Carousel
              infinite={false}
              initialSlide={firstPlanIndexOnboarding}
              ref={this.carouselRef}
              dots
              arrows
              slidesToShow={3}
              slidesToScroll={3}
              css={css`
                ul.slick-dots {
                  bottom: -11px;
                  & > li > button {
                    border: 1px solid ${colors.greyInputBorder};
                    border-radius: 3px;
                    background: ${colors.whiteBackground};
                    height: 6px;
                    opacity: 1;
                  }
                  & > li.slick-active > button {
                    background: ${colors.blueMed};
                    border: 1px solid ${colors.blueMed};
                  }
                }
                .slick-list {
                  padding-top: 11px;
                }
              `}
              nextArrow={<Arrow type="carousel-arrow-r" />}
              prevArrow={<Arrow flip type="carousel-arrow-r" />}
            >
              {displayedPlansOnboarding
                .filter(
                  plan =>
                    plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
                    plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY &&
                    plan.maxListedItems <= 10000,
                )
                .map((plan, index) => {
                  return (
                    <SubscriptionPlanCard
                      key={`plan-card-${plan.id}`}
                      selectedPlanCost={currentPlan ? currentPlan.monthlyCost || 0 : 0}
                      plan={plan}
                      selected={plan.id === currentPlanId}
                      currentPlanId={currentPlanId}
                      upgradePlan={() => this.handlePlanCardClick(index, plan.id)}
                      monthlyPayment={isMonthlyPayment}
                      disableUpgrade={disableUpgradePlan}
                      isJA={isJA}
                      htmlID={`tm-${plan.id}-card`}
                      isNonApi={isNonApi}
                      billableAccounts={billingAccount}
                    />
                  );
                })}
              {/* check if there are any custom plans and load them into the carousel */}
              {displayedPlansOnboarding.some(plan => plan.maxListedItems > 10000) && (
                <SubscriptionCustomPlanCard
                  displayedPlansOnboarding={displayedPlansOnboarding.filter(
                    plan =>
                      plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_TRAIL &&
                      plan.id !== eNums.SUBSCRIPTION_PLANS.FREE_HOLIDAY,
                  )}
                  isNonApi={isNonApi}
                  upgradePlan={this.handlePlanCardClick}
                  currentPlanId={currentPlanId}
                  monthlyPayment={isMonthlyPayment}
                  disableUpgrade={disableUpgradePlan}
                  isJA={isJA}
                  billableAccounts={billingAccount}
                  planStartingIndex={displayedPlansOnboarding.findIndex(
                    plan => plan.maxListedItems > 10000,
                  )}
                />
              )}
            </Carousel>
          )}
        </PlansContainer>
        {hoveringCardVisible && clickedPlan !== null && (
          <div
            css={css`
              position: fixed;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              z-index: 1;
            `}
          >
            <div
              css={css`
                position: absolute;
                overflow: auto;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
              `}
              id="subplancard_fill"
              onClick={this.closeCard}
            >
              <SubscriptionPlanCard
                key={`plan-card-${clickedPlan.id}`}
                selectedPlanCost={currentPlan ? currentPlan.monthlyCost || 0 : 0}
                plan={clickedPlan}
                selected={clickedPlan.id === currentPlanId}
                upgradePlan={hoveringCardAction}
                hoveringCardButtonMessage={hoveringCardButtonMessage}
                monthlyPayment={isMonthlyPayment}
                poppedOver
                closeCard={this.closeCard}
                recommendedPlanId={
                  clickedPlan.includesBIFMCatalog ? '' : clickedPlan.id.slice(0, -2)
                }
                openOtherPlanCard={this.handlePlanCardClick}
                clickedPlanBCR={clickedPlanBCR}
                isNonApi={isNonApi}
                noListDescription
                hoveringCardVisible
                billableAccounts={billingAccount}
              />
            </div>
          </div>
        )}
        {loading && <Spinner />}
      </>
    );
  }
}

export default QuickSubscriptionPicker;
